import { api } from './apiClient';
import type { InterviewResult } from '@/store/slices/interviewSlice';

interface PaginatedResults {
  results: InterviewResult[];
  total: number;
}

export const interviewService = {
  // Results
  async getInterviewResult(interviewUid: string): Promise<InterviewResult> {
    return api.interviewAgent.get(`/interview/${interviewUid}/result`);
  },

  async getAllResults(params: {
    page?: number;
    limit?: number;
    status?: string;
  }): Promise<PaginatedResults> {
    const response = await api.interviewAgent.get<{
      data: InterviewResult[];
      total: number;
    }>('/interview/results', { params });
    return {
      results: response.data,
      total: response.total,
    };
  },
};
